import React from "react";
import { Input, Select } from "antd";
import { ComponentInput, ComponentLine } from "../../styled";
import { formatCEP } from "../../../../../../../function/utilis/function";
const { Search } = Input;

export default function OptionEndereco({
  dadosCliente,
  setdadosCliente,
  statusInput,
  setstatusInput,
  listMunicipio,
  listEstado,
  buscaCep,
  loadingSearchCep,
}) {
  return (
    <>
      {/* CEP */}
      <ComponentLine>
        <ComponentInput>
          <p>CEP</p>
          <Search
            style={{ width: 240 }}
            placeholder={formatCEP(
              !dadosCliente.cep ? "CEP" : dadosCliente.cep
            )}
            value={formatCEP(dadosCliente.cep)}
            onSearch={buscaCep}
            loading={loadingSearchCep}
            status={statusInput === "cep" ? "error" : ""}
            onChange={(e) => {
              const value = e.target.value;
              setstatusInput(value === "" ? "error" : "");
              setdadosCliente((prev) => ({ ...prev, cep: value }));
            }}
          />
        </ComponentInput>
      </ComponentLine>

      {/* Logradouro, Número, Complemento */}
      <ComponentLine>
        <ComponentInput>
          <p>Logradouro</p>
          <Input
            style={{ width: 400 }}
            placeholder={!dadosCliente.logradouro ? "Logradouro" : dadosCliente.logradouro}
            value={dadosCliente.logradouro}
            status={statusInput === "logradouro" ? "error" : ""}
            onChange={(e) => {
              const value = e.target.value;
              setstatusInput(value === "" ? "error" : "");
              setdadosCliente((prev) => ({ ...prev, logradouro: value }));
            }}
          />
        </ComponentInput>

        <ComponentInput>
          <p>Número</p>
          <Input
            style={{ width: 100 }}
            placeholder={!dadosCliente.numero ? "Número" : dadosCliente.numero}
            value={dadosCliente.numero}
            status={statusInput === "numero" ? "error" : ""}
            onChange={(e) => {
              const value = e.target.value;
              setstatusInput(value === "" ? "error" : "");
              setdadosCliente((prev) => ({ ...prev, numero: value }));
            }}
          />
        </ComponentInput>

        <ComponentInput>
          <p>Complemento</p>
          <Input
            style={{ width: 240 }}
            placeholder={!dadosCliente.complemento ? "Complemento" : dadosCliente.complemento}
            value={dadosCliente.complemento}
            status={statusInput === "complemento" ? "error" : ""}
            onChange={(e) => {
              const value = e.target.value;
              setstatusInput(value === "" ? "error" : "");
              setdadosCliente((prev) => ({ ...prev, complemento: value }));
            }}
          />
        </ComponentInput>
      </ComponentLine>

      {/* Bairro, Cidade, Estado */}
      <ComponentLine>
        <ComponentInput>
          <p>Bairro</p>
          <Input
            style={{ width: 240 }}
            placeholder={!dadosCliente.bairro ? "Bairro" : dadosCliente.bairro}
            value={dadosCliente.bairro}
            status={statusInput === "bairro" ? "error" : ""}
            onChange={(e) => {
              const value = e.target.value;
              setstatusInput(value === "" ? "error" : "");
              setdadosCliente((prev) => ({ ...prev, bairro: value }));
            }}
          />
        </ComponentInput>

        <ComponentInput>
          <p>Cidade</p>
          <Select
            style={{ width: 260 }}
            showSearch
            value={dadosCliente.cidade}
            onChange={(value) =>
              setdadosCliente((prev) => ({ ...prev, cidade: value }))
            }
            filterOption={(input, option) =>
              (option?.label ?? "").toLowerCase().includes(input.toLowerCase())
            }
            options={listMunicipio.map((m) => ({
              value: m.nome,
              label: m.nome,
            }))}
          />
        </ComponentInput>

        <ComponentInput>
          <p>Estado</p>
          <Select
            style={{ width: 240 }}
            showSearch
            placeholder={
              listEstado.find((e) => e.uf === dadosCliente.estado)?.nome || "Estado"
            }
            value={
              listEstado.find((e) => e.uf === dadosCliente.estado)?.nome || undefined
            }
            onChange={(value) =>
              setdadosCliente((prev) => ({ ...prev, estado: value }))
            }
            filterOption={(input, option) =>
              (option?.label ?? "").toLowerCase().includes(input.toLowerCase())
            }
            options={listEstado.map((e) => ({
              value: e.uf,
              label: e.nome,
            }))}
          />
        </ComponentInput>
      </ComponentLine>
    </>
  );
}
